import { apiFetch } from '@/lib/api';

export type Role = 'admin' | 'member';

export interface Member {
  id: number;
  email: string;
  name: string;
  role: Role;
  is_active: boolean;
  created_at: string;
  last_login_at: string | null;
}

export interface Invitation {
  id: number;
  email: string;
  role: Role;
  expires_at: string;
  accepted_at: string | null;
  created_at: string;
}

export interface TeamList {
  members: Member[];
  pending_invitations: Invitation[];
}

export interface InviteRequest {
  email: string;
  role: Role;
}

export const teamService = {
  listMembers(): Promise<TeamList> {
    return apiFetch<TeamList>('/team/members');
  },

  invite(payload: InviteRequest): Promise<Invitation> {
    return apiFetch<Invitation>('/team/invitations', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  changeRole(id: number, role: Role): Promise<Member> {
    return apiFetch<Member>(`/team/members/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ role }),
    });
  },

  removeMember(id: number): Promise<void> {
    return apiFetch<void>(`/team/members/${id}`, { method: 'DELETE' });
  },

  revokeInvite(id: number): Promise<void> {
    return apiFetch<void>(`/team/invitations/${id}`, { method: 'DELETE' });
  },
};
